export class ListAzureStorageAccountContainers200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "containers",
            "baseName": "containers",
            "type": "Array<string>",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureStorageAccountContainers200Response.attributeTypeMap;
    }
    constructor() {
    }
}
